import { DeleteOutlined, HolderOutlined } from '@ant-design/icons'
import { HUB_PROPERTY_TYPE_ICONS } from '@salescore/client-common'
import {
  type ModelProperty,
  type ViewConfigField,
  type ViewConfigSheet,
  ViewConfigSheetValueObject,
} from '@salescore/core'
import { SortableFlexElement } from '@salescore/frontend-common'
import { Button, Row, Space } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

export const KpiFormSheetFieldsFormItemSorter = ({
  currentFields,
  currentSheet,
  setCurrentSheet,
}: {
  currentFields: Array<{ field: ViewConfigField; nodePathAsLabel: string[]; modelProperty: ModelProperty }>
  currentSheet: ViewConfigSheet
  setCurrentSheet: (sheetConfig: ViewConfigSheet) => void
}): ReactElement => {
  const sheet = new ViewConfigSheetValueObject(currentSheet)

  return (
    <div>
      <div className="mb-3">
        <div className="font-bold">{t(`選択した項目`)}</div>
      </div>

      <SortableFlexElement
        axis="y"
        onChange={(items) => {
          setCurrentSheet(sheet.set({ fields: items.map((x) => x.meta.field) }).config)
        }}
        items={currentFields.map((field) => ({
          // eslint-disable-next-line sonarjs/todo-tag
          key: JSON.stringify(field.field.property), // TODO
          meta: field,
          render() {
            return (
              <Row className="mb-1 rounded bg-white px-2 py-1" justify="space-between">
                <Space>
                  {<HolderOutlined />}
                  {HUB_PROPERTY_TYPE_ICONS[field.modelProperty.type]}
                  <span>
                    {field.nodePathAsLabel.join(': ')}: {field.modelProperty.label}
                  </span>
                </Space>
                <Space>
                  <Button
                    icon={<DeleteOutlined />}
                    type="text"
                    onClick={() => {
                      setCurrentSheet(sheet.removePropertyField(field.field.property).config)
                    }}
                  />
                </Space>
              </Row>
            )
          },
        }))}
      />
    </div>
  )
}
